/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ward: NonNullable<unknown>, district: NonNullable<unknown> }} Carrier_Legacy_LockedInputs */

const vi_carrier_legacy_locked = /** @type {(inputs: Carrier_Legacy_LockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem VTP in: ${i?.ward}, ${i?.district}`)
};

/**

* @param {Carrier_Legacy_LockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_locked = /** @type {((inputs: Carrier_Legacy_LockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_LockedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_locked(inputs)
});